import React, { FC, useEffect, useState } from 'react';
import '../../styles/components/buttonGroup.scss';

export interface IButton {
  title?: string;
  icon?: React.ReactNode;
  id: string;
  onClick: () => void;
}

interface IButtonGroupProps {
  buttons: IButton[];
  selectedId?: string;
}

export const ButtonGroup: FC<IButtonGroupProps> = ({ buttons, selectedId }) => {
  const [selected, setSelected] = useState<string>();

  const onClickButton = (id: string, onClick: () => void) => {
    setSelected(id);
    onClick();
  };

  useEffect(() => {
    setSelected(selectedId);
  }, [selectedId]);

  return (
    <div className='button-group'>
      {buttons.map(({ title, icon, id, onClick }) => (
        <div
          key={id}
          className={`button soft button-in-group ${selected === id ? 'selected' : ''}`}
          onClick={() => onClickButton(id, onClick)}
        >
          <>
            {icon}
            {title}
          </>
        </div>
      ))}
    </div>
  );
};
